import React from "react";
import { withRedux, isDigit } from "helpers";
import { BusinessForm, AboutUsForm, Input } from "components";
import { privateFetch } from "apis";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import { borderContainer } from "../editTemplate.styles";

// ping /checkUniqueAppCode
const checkUniqueAppCode = (appCode) => {
  if (appCode) {
    return new Promise((resolve, reject) => {
      return privateFetch(
        `${__BASE_API_URL__}/checkUniqueAppCode?code=${appCode}`
      )
        .then(resolve)
        .catch(reject);
    });
  }
};

const debouncedCheckUniqueAppCode = AwesomeDebouncePromise(
  checkUniqueAppCode,
  800
);
class EditAboutUs extends React.Component {
  // BusinessForm Props
  addLocation = () => {
    this.props.actions.addBusinessLocation();
  };

  addPhoneNumber = (locationIdx) => {
    this.props.actions.addBusinessPhoneNumber(locationIdx);
  };

  removeLocation = (locationIdx) => {
    this.props.actions.removeBusinessLocation(locationIdx);
  };

  removePhoneNumber = (locationIdx, phoneIdx, phoneId, appId) => {
    this.props.actions.removeBusinessPhoneNumber(
      locationIdx,
      phoneIdx,
      phoneId,
      appId
    );
  };

  updateBusiness = (field) => (value) => {
    this.props.actions.updateBusiness(field, value);
  };

  updateLocation = (locationIdx, key) => (value) => {
    this.props.actions.updateBusinessLocation(locationIdx, key, value);
  };

  updatePhoneNumber = (locationIdx, phoneIdx, key) => (value) => {
    this.props.actions.updateBusinessPhoneNumber(
      locationIdx,
      phoneIdx,
      key,
      value
    );
  };

  createBusinessApp = () => {
    const { business, activeApp } = this.props;
    this.props.actions.putBusinessApp(business, activeApp).then(() => {
      this.props.history.push({
        pathname: "/application",
      });
    });
  };

  // aboutUsProps
  updateImage = (url) => {
    this.props.actions.updateApplicationImage(url);
  };

  addLink = () => {
    this.props.actions.addApplicationLink();
  };

  removeLink = (linkIdx) => {
    this.props.actions.removeApplicationLink(linkIdx);
  };

  clearLink = (linkIdx) => {
    this.props.actions.updateApplicationLink("url", linkIdx, "");
  };

  updateLinkIcon = (image, linkIdx) => {
    this.props.actions.updateApplicationLink("icon", linkIdx, image.url);
  };

  updateLink = (field, linkIdx) => (e) => {
    let value = e.currentTarget.value;
    this.props.actions.updateApplicationLink(field, linkIdx, value);
  };
  updateLogoImage = (url) => {
    // console.log("updating logo pic " + url);
    let updatedApp = this.props.activeApp;
    // console.log(updatedApp);
    if (url) {
      if (updatedApp.logo === null) {
        // console.log("found null logo");
        this.props.actions.updateApplicationInfo("logo", url);
      } else {
        // console.log("a logo exists");
        this.props.actions.updateApplicationInfo("logo", url);
      }
    } else {
      this.props.actions.updateApplicationInfo("logo", "");
    }
  };

  updateApp = (field) => (value) => {
    if (field === "code") {
      debouncedCheckUniqueAppCode(value).then((appCodeAvailable) => {
        this.props.actions.updateApplicationInfo(
          "appCodeAvailable",
          appCodeAvailable
        );
      });
    }

    this.props.actions.updateApplicationInfo(field, value);
  };

  render() {
    const { activeApp, business } = this.props;
    if (!activeApp) throw new Error("Edit meta needs active application");

    const aboutUsProps = {
      updateImage: this.updateImage,
      updateLogoImage: this.updateLogoImage,
      addLink: this.addLink,
      removeLink: this.removeLink,
      clearLink: this.clearLink,
      updateLinkIcon: this.updateLinkIcon,
      updateLink: this.updateLink,
      updateApp: this.updateApp,
    };

    const {
      mainImageLink,
      links,
      name,
      website,
      code,
      appCodeAvailable,
      oldAppCode,
    } = activeApp;

    return (
      <div>
        <AboutUsForm application={this.props.activeApp} {...aboutUsProps} />

        <BusinessForm
          addLocation={this.addLocation}
          business={business}
          addPhoneNumber={this.addPhoneNumber}
          removeLocation={this.removeLocation}
          removePhoneNumber={this.removePhoneNumber}
          updateBusiness={this.updateBusiness}
          updateLocation={this.updateLocation}
          updatePhoneNumber={this.updatePhoneNumber}
          createBusinessApp={this.createBusinessApp}
          application={activeApp}
        />
      </div>
    );
  }
}

export default withRedux(EditAboutUs);
